<div class="flex flex-col gap-4">
  <div class="mt-2"><app-back-button /></div>
  <span class="text-2xl font-bold mb-4">Nueva adhesión</span>
  <app-stepper
    [steps]="steps()"
    (valueChange)="onStepConfirm($event)"
    [stepCurrent]="currentView()" />
  @switch (currentView()) {
    @case (1) {
      <app-step1
        (viewProtocolDetails)="goViewProtocolDetails($event)"
        (dataChange)="onStep1Completed($event)" />
    }
    @case (2) {
      <app-step2
        [nameProtocol]="protocolName()"
        (dataChange)="onStep2Completed($event)" />
    }
    @case (3) {
      <app-step3
        [formData]="step3FormData"
        (formDataChange)="step3FormData = $event"
        (formIsValid)="formIsValid($event)"
        (step3Completed)="onStep3Completed($event)"></app-step3>
    }
    @case (4) {
      <app-step4
        [addedRpts]="newAccessionData.rpts"
        (step4IsValid)="onStep4ValidityChange($event)"
        (step4Completed)="onStep4Completed($event)"
        [nameAndRange]="newAccessionData.name ?? ''" />
    }
    @case (5) {
      <app-step5
        [data]="newAccessionData"
        (goStepFN)="onStepSelected($event)" />
    }
    @case (6) {
      <app-protocol-details
        (dataChange)="onStep1Completed($event)"
        (goProtocolsView)="onStepSelected(1)"
        [protocol]="protocolSelected()"></app-protocol-details>
    }
  }
  <p-confirmdialog />
</div>
